import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { obtenerUsuario, hasAllPerms, hasAnyPerm } from "../services/authServices";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

// alguno = alcanza con UNO de los permisos (p. ej. Grupos de costos: costos:read o reportes:read,
// igual que el backend). Sin `alguno`, hacen falta todos (comportamiento de siempre).
export default function RequirePerms({ perms, alguno, children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    (async () => {
      const u = await obtenerUsuario();
      if (!alive) return;
      setUser(u);
      setLoading(false);
      if (!u || !(alguno ? hasAnyPerm(u, perms) : hasAllPerms(u, perms))) {
        navigate("/dashboard", { replace: true });
      }
    })();
    return () => { alive = false; };
  }, [navigate, perms, alguno]);

  if (loading) {
    return (
      <Box sx={{ display:"grid", placeItems:"center", height:"70vh" }}>
        <CircularProgress />
      </Box>
    );
  }
  return children;
}

RequirePerms.propTypes = {
  perms: PropTypes.arrayOf(PropTypes.string).isRequired,
  alguno: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
RequirePerms.defaultProps = { alguno: false };
